import styled from 'styled-components'

export const FilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        gap: 0.5rem;
        padding-bottom: 0.5rem;

        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
    }
`

export const FilterButton = styled.button`
    width: fit-content;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: #5a5a5d;
    background-color: #eff1f4;
    border-radius: 2px;
    border: none;
    margin: 0.5rem;
    padding: 0.75rem 1.5rem;
    cursor: pointer;

    &.active {
        color: #fff;
        background-color: #ba9d31;
    }

    @media (max-width: 768px) {
        flex: 0 0 auto;
        margin: 0;
        padding: 0.75rem 1rem;
        font-size: 14px;
        text-align: center;
    }
`
